import { jsPDF } from "jspdf";
import "jspdf-autotable";
import _ from "lodash";
import moment from "moment";
import eatprestoLogo from "../../../../../assets/images/logos/logo.png";
import { ExportPdfColor } from "../../../../../root/theme/exportColor";

const handleNodeAndFooterLength = (key: any, nodes: any) => {
  let nodeLength = 0;
  if (key === "cancelled-receipts") {
    nodeLength = nodes["cancelledSaleNodesLength"];
  } else if (key === "void-transaction") {
    nodeLength = nodes["voidTransactionNodesLength"];
  } else if (key === "paid-in-out") {
    nodeLength = nodes["paidInOutNodesLength"];
  } else {
    nodeLength = 0;
  }
  return { nodeLength };
};

const handleConvertPdf = (
  doc: any,
  filterDetails: any,
) => {
  const locationFilter = filterDetails.split("*")[0];
  const pageWidth = doc.internal.pageSize.getWidth();
  /* Create a pdf file. */
  doc.autoTable({
    // Add topic and sub topics.
    didDrawPage: function (data: any) {
      // Change topic font size
      doc.setFontSize(12);
      doc.text("Presto Express Solutions", data.settings.margin.left, 12);
      // Modify the marginLeft according to the scape.
      doc.text("Shift Summary Report", data.settings.margin.left + 140, 12);
      // Change main title font size
      doc.setFontSize(16);
      // Insert a topic for the first page only.
      if (doc.internal.getNumberOfPages() === 1) {
        /* Change the title according to the number of locations.
        If the location size is increased, show presto express. if the location size is the one, show that location. */
        doc.setTextColor("#32363E");
        if (locationFilter.includes(",")) {
        } else {
          doc.text(
            filterDetails
              .split("*")[0]
              .replace("Shift summary report for location/s:", ""),
            pageWidth / 2,
            36,
            {
              align: "center",
            },
          );
        }

        doc.setTextColor(0, 0, 0);
        doc.text("Shift Summary Report", pageWidth / 2, 56, "center");
        doc.setFontSize(10);

        /* Change the sub title according to the number of locations.
        If the location size is increased, show number of locations. if the location size is the one, show that location. */
        let filterLocationsDetails = "";
        if (locationFilter.split(",").length === 1) {
          filterLocationsDetails =
            "Shift Summary Report for " + locationFilter.split(",")[0];
        } else {
          filterLocationsDetails =
            "Shift Summary Report for " +
            locationFilter.split(",").length +
            " Locations";
        }

        doc.text(
          doc.splitTextToSize(filterLocationsDetails, 210 - 15 - 15),
          pageWidth / 2,
          44,
          {
            align: "center",
          },
        );
      }


    },
    margin: {
      top: 30,
      bottom: 30,
    },
  });
};

const handleTable = (
  key: any,
  doc: any,
  pdfHeader: any,
  nodes: any,
  startY: any,
  lastIndex: any,
  nodeLength: any,
) => {
  const columnLength: number = pdfHeader.length;
  const pageWidth = doc.internal.pageSize.getWidth();
  const totalPagesExp = "{total_pages_count_string}";

  /* Create a new table. */
  doc.autoTable({
    columns: pdfHeader.map((col: any) => ({ ...col, dataKey: col.field })),
    body: nodes,
    showHead: key === "Banking" || key === "Summary" ? "never" : "everyPage",
    startY: startY,
    styles: {
      align: "center",
      fontSize: 8,
      valign: "middle",
      halign: "center",
      borderRadius: "10px",
    },
    headStyles: {
      fillColor: [ExportPdfColor.HeaderRowColor],
      textColor: ["#ffffff"],
      fontSize: 7,
      valign: "middle",
      halign: "center",
    },
    columnStyles: {
      0: {
        fontStyle: "bold",
        halign: "left",
        columnWidth: (pageWidth - 28.2) / columnLength,
      },
      1: { halign: "center", columnWidth: (pageWidth - 28.2) / columnLength },
      2: { halign: "center", columnWidth: (pageWidth - 28.2) / columnLength },
      3: { halign: "center", columnWidth: (pageWidth - 28.2) / columnLength },
      4: { halign: "center", columnWidth: (pageWidth - 28.2) / columnLength },
      5: { halign: "center", columnWidth: (pageWidth - 28.2) / columnLength },
      6: { halign: "center", columnWidth: (pageWidth - 28.2) / columnLength },
    },
    alternateRowStyles: {
      fillColor: [ExportPdfColor.OddRowColor],
      textColor: ["#ffffff"],
    },
    tableLineWidth: 0.1,

    /* Use the green footer only for other tables, as there is no footer for a 
    breakdown of shifts, banking, and summary tables. */
    willDrawCell: function (data: any) {
      if (
        key !== "Breakdown of Shifts" &&
        key !== "Banking" &&
        key !== "Summary"
      ) {
        const rows = data.table.body;
        if (data.row.index === rows.length - 1) {
          doc.setFillColor(ExportPdfColor.green);
          doc.setTextColor(255, 255, 255);
        }
      }
    },
    /* Change the background color, font weight and alignment in the row. */
    didParseCell: function (data: any, index: any) {
      const rows = data.table.body;

      if (data.section === "head") {
        if (data.column.index === 0) {
          data.cell.styles.halign = "left";
        }
      }
      if (data.column.index === lastIndex) {
        data.cell.styles.halign = "right";
      }
      if (data.row.index !== 0) {
        if (nodeLength > 0) {
          if (data.row.index < nodeLength) {
            if (data.row.index % 2 === 0) {
              data.cell.styles.fillColor = [ExportPdfColor.OddRowColor];
              data.cell.styles.textColor = ["#ffffff"];
            } else {
              data.cell.styles.fillColor = [ExportPdfColor.EvenRowColor];
              data.cell.styles.textColor = ["#ffffff"];
            }
          } else {
            if (
              data.row.raw.Date === "Pay In" ||
              data.row.raw.Date === "Pay Out"
            ) {
              data.cell.styles.fillColor = [ExportPdfColor.purple];
              data.cell.styles.textColor = ["#ffffff"];
              data.cell.styles.fontStyle = "bold";
            } else {
              data.cell.styles.fillColor = [ExportPdfColor.blueDark];
              data.cell.styles.textColor = ["#ffffff"];
              data.cell.styles.fontStyle = "bold";
            }
          }
        } else {
          if (data.row.index % 2 === 0) {
            data.cell.styles.fillColor = [ExportPdfColor.OddRowColor];
            data.cell.styles.textColor = ["#ffffff"];
          } else {
            data.cell.styles.fillColor = [ExportPdfColor.EvenRowColor];
            data.cell.styles.textColor = ["#ffffff"];
          }
        }
      }
      if (
        data.row.index + 1 === rows.length &&
        key !== "Breakdown of Shifts" &&
        key !== "Pay In Out" &&
        key !== "Banking" &&
        key !== "Summary"
      ) {
        data.cell.styles.fontStyle = "bold";
      }
    },
    didDrawPage: function (data: any) {
      let pageNumber = "Page " + doc.internal.getNumberOfPages();

      /* If there is a image, insert it into the eatprestoLogoImg variable. */
      const eatprestoLogoImg = new Image();
      eatprestoLogoImg.src = eatprestoLogo;
      /* Set page number */
      let pageSize = doc.internal.pageSize;
      const pageHeight = pageSize.height
        ? pageSize.height
        : pageSize.getHeight();

              // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === "function") {
        pageNumber = pageNumber + " of " + totalPagesExp;
      }
      doc.setFontSize(10);
      doc.text(pageNumber, data.settings.margin.left, pageHeight - 10);

      doc.addImage(
        eatprestoLogoImg,
        "JPEG",
        data.settings.margin.left + 144,
        pageHeight - 24,
        40,
        16,
      );
    },
    margin: {
      top: 30,
      bottom: 30,
    },
  });

  if (typeof doc.putTotalPages === "function") {
    doc.putTotalPages(totalPagesExp);
  }
};

/* Create a pdf file */
export const handlePdf = (filterDetails: any, pdfHeader: any, nodes: any) => {
  const doc: any = new jsPDF("p");


  const today = moment().format("MMM_Do_YY").toString();

  /* If there is a image, insert it into the eatprestoLogoImg variable. */
  const eatprestoLogoImg = new Image();
  eatprestoLogoImg.src = eatprestoLogo;

  let startY = 65;

  /* Iterating table data */
  Object.entries(nodes).forEach(([key, value]: any) => {
    if (!key.includes("_tableName") && !_.isEmpty(value)) {
      // Get the number of columns in the table
      let lastIndex = Object.values(value[0]).length - 1;
      if (key === "paid-in-out") {
        lastIndex = lastIndex - 1;
      }
      // If the height of the previous table is greater than 240, a new page is added.
      if (startY > 240) {
        doc.addPage();
        startY = 30;
      }

      const { nodeLength } = handleNodeAndFooterLength(key, nodes);
      handleConvertPdf(doc, filterDetails);
      doc.text(nodes[`${key}_tableName`], 14, startY);
      handleTable(
        key,
        doc,
        pdfHeader[key],
        value,
        startY + 8,
        lastIndex,
        nodeLength,
      );
      startY = doc.lastAutoTable.finalY + 13;
    }
  });

  doc.save(`shift_${today}_${Math.floor(100000 + Math.random() * 900000)}.pdf`);
};
